var _title, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAgeRating18 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 21 21",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "18+")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2496563,0 C19.7686292,0 21,1.23137084 21,2.75034375 L21,18.2496563 C21,19.7686292 19.7686292,21 18.2496563,21 L2.75034375,21 C1.23137084,21 0,19.7686292 0,18.2496563 L0,2.75034375 C0,1.23137084 1.23137084,0 2.75034375,0 L18.2496563,0 Z M18.2496563,1 L2.75034375,1 C1.83199,1 1.07882314,1.70724917 1.00580234,2.60678835 L1,2.75034375 L1,18.2496563 C1,19.16801 1.70724917,19.9211769 2.60678835,19.9941977 L2.75034375,20 L18.2496563,20 C19.16801,20 19.9211769,19.2927508 19.9941977,18.3932117 L20,18.2496563 L20,2.75034375 C20,1.83199 19.2927508,1.07882314 18.3932117,1.00580234 L18.2496563,1 Z M14.035865,7 C15.9490539,7 17.5,8.56700338 17.5,10.5 C17.5,12.4329966 15.9490539,14 14.035865,14 C12.4516866,14 11.1158742,12.9256089 10.7032856,11.4586713 L8.377,11.458 L8.37763713,14 L6.66455696,14 L6.664,11.458 L5.24548426,11.4585366 L5.24548426,14 L3.5,14 L3.5,9.55243902 L10.7001889,9.55240864 C11.109154,8.07980424 12.4477007,7 14.035865,7 Z M14.035865,8.90909091 C13.1662336,8.90909091 12.4612582,9.62136517 12.4612582,10.5 C12.4612582,11.3786348 13.1662336,12.0909091 14.035865,12.0909091 C14.9054963,12.0909091 15.6104718,11.3786348 15.6104718,10.5 C15.6104718,9.62136517 14.9054963,8.90909091 14.035865,8.90909091 Z",
    id: "18+",
    fill: "#D54E4D",
    fillRule: "nonzero"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAgeRating18, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/age_rating_18.b41b31c6.svg";
export { ForwardRef as ReactComponent };